import * as React from "react";
import { useTheme } from "@mui/material/styles";
import {
	Box,
	Checkbox,
	FormGroup,
	FormControlLabel,
	MobileStepper,
	Typography,
	Button,
} from "@mui/material";
import Image from "../../../ui-components/Image";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

export default function MultipleSelect({ question, onAnswer = () => {} }) {
	const [answer, setAnswer] = React.useState([]);
	const [activeStep, setActiveStep] = React.useState(0);
	const theme = useTheme();
	const maxSteps =
		typeof question.questionImage === "string"
			? 0
			: question.questionImage.length;
	React.useEffect(() => {
		// reset proceed button
		setAnswer([]);
	}, [question]);

	const handleSetAnswer = (e) => {
		let ans = [...answer];
		if (ans.indexOf(e.target.value) >= 0) {
			ans = ans.filter((a) => a !== e.target.value);
		} else {
			ans.push(e.target.value);
		}
		setAnswer(ans);

		const canProceed = ans.length >= 1;

		onAnswer({
			canProceed,
			answer: ans,
		});
	};

	// const splitIntoColumns = (choices, itemsPerColumn = 6) => {
	// 	const numberOfColumns = Math.ceil(choices.length / itemsPerColumn);
	// 	const columns = Array.from({ length: numberOfColumns }, (_, colIndex) =>
	// 		choices.slice(
	// 			colIndex * itemsPerColumn,
	// 			(colIndex + 1) * itemsPerColumn
	// 		)
	// 	);
	// 	return columns;
	// };

	// const columns =
	// 	question.questionList.length > 6
	// 		? splitIntoColumns(question.questionList)
	// 		: [question.questionList];

	return (
		<React.Fragment>
			<Box
				sx={{
					width: "100%",
					background: "white",
					pb: 2,
					pt: 1,
					px: 1,
				}}
				className="image-container"
			>
				<Image
					src={`${
						typeof question.questionImage === "string"
							? question.questionImage
							: question.questionImage[activeStep]
					}`}
                    style={{ minHeight: "374px"}}
				/>
				{typeof question.questionImage !== "string" && (
					<MobileStepper
						variant="text"
						steps={maxSteps}
						position="static"
						activeStep={activeStep}
						nextButton={
							<Button
								size="small"
								onClick={() => {
                                    setActiveStep(activeStep + 1);
                                }}
								disabled={activeStep === maxSteps - 1}
							>
								Next
								{theme.direction === "rtl" ? (
									<KeyboardArrowLeft />
								) : (
									<KeyboardArrowRight />
								)}
							</Button>
						}
						backButton={
							<Button
								size="small"
                                onClick={() => {
                                    setActiveStep(activeStep - 1);
                                }}
								disabled={activeStep === 0}
							>
								{theme.direction === "rtl" ? (
									<KeyboardArrowRight />
								) : (
									<KeyboardArrowLeft />
								)}
								Back
							</Button>
						}
					/>
				)}
			</Box>
			<Box className="choices-container" sx={{ px: { xs: 4, sm: 8 } }}>
				<FormGroup>
					{question.questionList.map((data, i) => (
						<FormControlLabel
							sx={{
								mx: 0,
							}}
							className={`checkbox-selection-label q-mselect ${
								answer.indexOf(data.value || data) >= 0
									? "selected"
									: ""
							}`}
							key={`selection-${i}-${Math.random()}`}
							control={
								<Checkbox
									sx={{ display: "none" }}
									defaultChecked={
										answer.indexOf(data.value || data) >= 0
									}
									value={data.value || data}
									onChange={handleSetAnswer}
								/>
							}
							label={
								<Typography
									className="checkbox-selection-text"
									sx={{
										margin: 0,
										color:
											answer.indexOf(data.value || data) <
											0
												? "#06b6ad"
												: "white",
									}}
								>
									{data.label || data}
								</Typography>
							}
						/>
					))}
				</FormGroup>
			</Box>
		</React.Fragment>
	);
}
